import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

export type LatestAlert = {
  id: number;
  contentsite_id: number;
  alert_text: string;
  alert_type: string;
  active: number;
  platform: string;
  format: string;
  rss_img_url?: string;
  rss_title: string;
  created_at: string | Date;
  Domain: string;
  posting_queue_id: number;
};

@Component({
  selector: 'app-latest-alerts',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
  ],
  templateUrl: './latest-alerts.component.html',
})
export class LatestAlertsComponent {
  @Input() alerts: LatestAlert[] = [];
  @Input() maxSidebarCards = 3;
  @Input() naPlaceholder = './assets/images/na.png';
  @Input() title = 'Latest alerts';

  @Output() viewAlert = new EventEmitter<LatestAlert>();

  get visibleAlerts(): LatestAlert[] {
    return (this.alerts || []).slice(0, this.maxSidebarCards);
  }

  trackByAlertId = (_: number, item: LatestAlert): number => item.id;

  onViewAlert(alert: LatestAlert): void {
    this.viewAlert.emit(alert);
  }

  onMainImgError(ev: Event): void {
    const img = ev.target as HTMLImageElement;

    if (!img || img.src.endsWith(this.naPlaceholder)) {
      return;
    }

    img.src = this.naPlaceholder;
  }

  platformTextClass(plat?: string): string {
    const t = (plat || '').toLowerCase().trim();

    switch (t) {
      case 'instagram':
        return 'text-fuchsia-600';

      case 'facebook':
        return 'text-blue-600';

      case 'x':
        return 'text-neutral-700';

      case 'youtube':
        return 'text-red-600';

      default:
        return 'text-gray-700';
    }
  }

  alertTextClass(alertType?: string): string {
    const type = alertType || '';

    if (type.startsWith('Low')) {
      return 'text-red-600';
    }

    if (type.includes('Spike')) {
      return 'text-green-600';
    }

    return 'text-gray-700';
  }

  alertIcon(alertType?: string): string {
    return (alertType || '').includes('Spike') ? '▲' : '▼';
  }
}